import { addMinutes, isAfter } from 'date-fns';
import store from '../store';

export const BOOKING_STATUS = {
  NOSHOW: 'NOSHOW',
  ABSENCE: 'ABSENCE',
  ATTENDANCE: 'ATTENDANCE',
  LATE: 'LATE',
  BOOKED: 'BOOKED',
  CANCEL: 'CANCEL'
};

export const PRESENT_BOOKING_STATUS = {
  BOOKED: '예약',
  CANCELLED: '취소',
  ABSENCE: '결석',
  NOSHOW: '결석',
  ATTENDANCE: '출석',
  LATE: '지각',
  WAITING: '대기'
};

export function getBookingStatus({ status, attendance, dt: courseStart }) {
  const lateTime = store.getters.getPolicy.late_from;

  if (!attendance) {
    if (isAfter(addMinutes(courseStart, lateTime), new Date())) {
      // 미래인 수업: "BOOKED", "CANCEL"
      return status;
    }

    if (status === BOOKING_STATUS.BOOKED) {
      // 과거 예약된 수업: "NOSHOW", "ABSENCE", "ATTENDANCE", "LATE"
      return 'NOSHOW';
    }
    return status;
  }

  if (attendance.status !== BOOKING_STATUS.NOSHOW) {
    // "ABSENCE", "ATTENDANCE", "LATE"
    return attendance.status;
  }

  if (isAfter(addMinutes(courseStart, lateTime), new Date())) {
    // 미래인 수업: "BOOKED", "CANCEL"
    return status;
  }

  if (status === BOOKING_STATUS.BOOKED) {
    // 과거 예약된 수업: "NOSHOW", "ABSENCE", "ATTENDANCE", "LATE"
    return attendance.status;
  }

  // 과거 취소된 수업 "CANCEL"
  return status;
}
